import '@gjensidige/core-expandable/lib-css/index.css';
import '@gjensidige/core-buttons/lib-css/index.css';

import React from 'react';
import classNames from 'classnames';
import { PrimaryButton } from '@gjensidige/core-buttons/lib-css/primary-button';
import { Expandable } from '@gjensidige/core-expandable/lib-css/expandable';
import utils from '@gjensidige/core-utilities-css';

import { FaqListProps as Props } from './types';

import styles from '../less/faq.module.less';

const FaqList = ({ questions }: Props) => (
  <>
    {questions?.length > 0 &&
      questions.map((question, index) => (
        <Expandable
          key={`${question.question}_${index}`}
          ariaControlId={`faq_${index}_${question._id ?? index}`}
          wrapperClassName={styles.expandableWrapper}
          buttonClassName={styles.expandableButton}
        >
          {{
            header: question.question,
            content: (
              <div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: question.answer
                  }}
                ></div>
                {question?.button?.linkTarget && question?.button?.linkText && (
                  <PrimaryButton
                    className={classNames(utils['mt-2'])}
                    href={question.button.linkTarget}
                    color="blue"
                  >
                    {question.button.linkText}
                  </PrimaryButton>
                )}
              </div>
            )
          }}
        </Expandable>
      ))}
  </>
);

export default FaqList;
